export default function setupPhraseAppInContextEditor(messages) {
  const url = new URL(window.location);
  const searchParams = new URLSearchParams(url.search);
  const phraseAppProjectId = searchParams.get("phraseapp");

  if (!phraseAppProjectId) {
    return messages;
  }

  const prefix = "PHRASEAPPPREFIX";
  const suffix = "PHRASEAPPSUFFIX";

  window.PHRASEAPP_ENABLED = true;
  window.PHRASEAPP_CONFIG = {
    prefix,
    suffix,
    autoLowercase: false,
    fullReparse: true,
    debugMode: true,
    projectId: phraseAppProjectId,
  };

  const phraseapp = document.createElement("script");
  phraseapp.type = "text/javascript";
  phraseapp.async = true;
  phraseapp.src = [
    "https://",
    "phraseapp.com/assets/in-context-editor/2.0/app.js?",
    new Date().getTime(),
  ].join("");
  var s = document.getElementsByTagName("script")[0];
  if (s !== undefined) {
    s.parentNode.insertBefore(phraseapp, s);
  } else {
    document.insertBefore(phraseapp, null);
  }

  return Object.keys(messages).reduce((messages, key) => {
    messages[key] = `${prefix}phrase_${key}${suffix}`;
    return messages;
  }, {});
}
